import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../services/common.service';
import { GenericHomeComponent } from '../../../pages/generic-home/generic-home.component';
import { EducationHomeComponent } from '../../../pages/education-home/education-home.component';

@Component({
  selector: 'app-flow-router',
  standalone: true,
  imports: [
    CommonModule,
    GenericHomeComponent,
    EducationHomeComponent
  ],
  templateUrl: './flow-router.component.html',
  styleUrl: './flow-router.component.scss'
})
export class FlowRouterComponent implements OnInit {

  constructor(protected commonService: CommonService) {}

  ngOnInit() {
  }


}
